import { Program } from '../../shared/program/model/program';
import { Injectable } from '@angular/core';

@Injectable()
export class ProgramContext {
    program: Program;
}
